export const countdownRef = 'custom-countdown';



// WEBPACK FOOTER //
// ./src/plugins/countDown/consts.js